import { getHidratationKey } from '@portal-internet/core';
import Imatge, { hasImatge } from 'components/3catinfo/Imatge';
import Boto from 'components/3catinfo/Boto';
import BotoSeguir from 'components/3catinfo/BotoSeguir';
import InnerHTML from 'dangerously-set-html-content';
import __isEmpty from 'lodash/isEmpty';
import styles from './capcaleraautor.module.scss';
import Compartir from '../Compartir/Compartir';
import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { useViewport } from 'hooks/3catinfo/useViewport';

const TruncatedText = (props) => {
    const { text } = props;
    const [isTruncated, setIsTruncated] = useState(false);
    const [showFullText, setShowFullText] = useState(false);
    const textRef = useRef(null);
    const hidratationKey = getHidratationKey(text);

    useEffect(() => {
        const element = textRef.current;
        if (element?.scrollHeight > element?.clientHeight) {
            setIsTruncated(true);
        }
    }, []);

    const handleToggleText = () => {
        setShowFullText(!showFullText);
    };
    const stylesText = clsx({
        [styles.text]: true,
        [styles.show_full]: !!showFullText
    });
    return text ? (
        <div className={styles.content_paragraph} data-testid='item-autor-biografia'>
            <div ref={textRef} className={stylesText}>
                <InnerHTML key={hidratationKey} html={text} />
            </div>
            {isTruncated && (
                <Boto
                    tag='button'
                    onClick={handleToggleText}
                    estil='llegeixMes'
                    iconaInline={true}
                    icona={showFullText ? 'fletxa_simple_amunt' : 'fletxa_simple_avall'}
                    text={showFullText ? 'Llegeix menys' : 'Llegeix més'}
                />
            )}
        </div>
    ) : (
        <></>
    );
};

export default function CapcaleraAutor(props) {
    const { autor, mostrarTwitter = true, mostrarSegueix = true, dataTestId } = props;
    const { imatges, id, nom, carrec, descripcio, biografia, twitter } = autor;
    const descripcioText = carrec || descripcio;
    const hasImatges = hasImatge(imatges, 'web_autor', null, null);
    const { isMobile } = useViewport();

    const getImatge = () => {
        return hasImatges ? (
            <figure key={`autor-imatge`} className={styles.autor_imatge}>
                <span>
                    <Imatge
                        imatges={imatges}
                        tipus='web_autor_capcalera'
                        alt={imatges?.[0]?.alt}
                        layout='fill'
                        objectFit='cover'
                        mostrarRecursTitol={false}
                        mostrarRecurs={false}
                    />
                </span>
            </figure>
        ) : (
            <div key={`autor-imatge`} className={styles.autor_imatge_default}>
                <span>
                    <Imatge
                        src='/_resources/imatges/3catinfo/autor.png'
                        tipus='web_autor_capcalera'
                        layout='fill'
                        mostrarRecursTitol={false}
                        mostrarRecurs={false}
                    />
                </span>
            </div>
        );
    };
    return (
        <div className={styles.capcalera_autor} data-testid={dataTestId || 'item-autor'}>
            <div className={styles.container}>
                <div className={styles.content_body}>
                    <div className={styles.content}>
                        <div className={styles.content_title} data-testid={`${dataTestId || 'item-autor'}-autors`}>
                            <h1 className={styles.title}>{nom}</h1>

                            {descripcioText && (
                                <h2 className={styles.description} data-testid='item-autor-descripcio'>
                                    {descripcioText}
                                </h2>
                            )}
                        </div>
                        <TruncatedText text={biografia} />
                    </div>
                    <div className={styles.buttonbar}>
                        <div className={styles.col_left}>
                            {mostrarSegueix && (
                                <div data-testid='item-autor-segueix'>
                                    <BotoSeguir
                                        textHitAudiencies={nom}
                                        obreEsquerra={isMobile}
                                        id={id}
                                        tipologia={'NOT_AUTOR'}
                                        estil='petit'
                                        textMissatge={nom}
                                        enviaApi={true}
                                    />
                                </div>
                            )}
                        </div>

                        <div className={styles.col_right} data-testid='item-autor-twitter'>
                            {twitter && mostrarTwitter && (
                                <Boto
                                    icona='ic_twitter'
                                    isIconaBlanc={true}
                                    isIconaDreta={false}
                                    estil='twitter'
                                    novaFinestra={true}
                                    className={styles.button_twitter}
                                    link={`https://twitter.com/${twitter}`}
                                    ariaLabel={`Compte X - ${twitter}`}
                                    text={twitter}
                                />
                            )}
                            <Compartir obreEsquerra={true} estil='small' />
                        </div>
                    </div>
                </div>
                <div className={styles.content_imatge}>{getImatge()}</div>
            </div>
        </div>
    );
}
